import { AdminPageLayout } from "@/features/admin/components/AdminPageLayout";
import { useNav } from "@/utils/nav";
import { stateIcons } from "@patient-watch/icons";
import { ui } from "@patient-watch/ui";
import { createFileRoute } from "@tanstack/react-router";
import type { ComponentType } from "react";

export const Route = createFileRoute("/_app/design/icons/states")({
    component: StateIconsDemo,
});

const STATE_COMPONENTS = Object.entries(stateIcons).sort(([left], [right]) => left.localeCompare(right)) as [
    string,
    ComponentType,
][];

const FlagIcon = stateIcons.Flag;

const FLAG_VARIANTS = [
    { label: "green", color: "green" as const },
    { label: "amber", color: "amber" as const },
    { label: "red", color: "red" as const },
    { label: "black", color: "black" as const },
    { label: "gray", color: "gray" as const },
];

function StateIconsDemo() {
    useNav([
        { label: "Design", route: { to: "/design" } },
        { label: "Icons", route: { to: "/design/icons" } },
        { label: "States", route: { to: "/design/icons/states" } },
    ]);

    return (
        <AdminPageLayout
            title="State icons"
            description="Diary and workflow state illustrations from @patient-watch/icons."
            maxWidthClassName="max-w-5xl"
        >
            <div className="gap-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4">
                {STATE_COMPONENTS.map(([name, Icon]) => (
                    <ui.Card key={name}>
                        <ui.CardContent className="flex flex-col items-center gap-4 p-6">
                            <div className="flex justify-center items-center w-16 h-16">
                                <Icon />
                            </div>
                            <p className="font-mono text-sm text-center">{name}</p>
                        </ui.CardContent>
                    </ui.Card>
                ))}
            </div>

            <div className="mt-10">
                <h2 className="mb-4 font-semibold text-lg">Flag colours</h2>
                <div className="gap-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5">
                    {FLAG_VARIANTS.map(({ label, color }) => (
                        <ui.Card key={label}>
                            <ui.CardContent className="flex flex-col items-center gap-4 p-6">
                                <div className="flex justify-center items-center w-16 h-16">
                                    <FlagIcon color={color} />
                                </div>
                                <p className="font-mono text-sm text-center">{label}</p>
                            </ui.CardContent>
                        </ui.Card>
                    ))}
                </div>
            </div>
        </AdminPageLayout>
    );
}
